import { ComponentType, lazy } from 'react'

export const safeLazy = <P extends object>(
  importFn: () => Promise<{ default: ComponentType<P> }>
) => {
  return lazy(async () => {
    try {
      return await importFn()
    } catch (error: unknown) {
      const name = error instanceof Error ? error.name : undefined
      const message = error instanceof Error ? error.message : ''
      const isHookError =
        name === 'ChunkLoadError' ||
        message.includes('Failed to fetch dynamically imported module') ||
        message.includes('Importing a module script failed') ||
        message.includes('error loading dynamically imported module') ||
        message.includes('Load failed')

      if (isHookError) {
        const storageKey = 'app-reload-on-error'
        const lastReload = sessionStorage.getItem(storageKey)
        const now = Date.now()

        if (!lastReload || now - parseInt(lastReload) > 10000) {
          sessionStorage.setItem(storageKey, now.toString())
          sessionStorage.setItem(
            'app-reload-from-chunk-error',
            window.location.pathname
          )
          console.warn(
            'Chunk load error detected. Reloading page to get latest version...'
          )
          window.location.reload()
        }
        await new Promise(() => {})
      }

      throw error
    }
  })
}
